import {Component, inject, PLATFORM_ID} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {WebinarHeroComponent} from '../../components/webinar-hero/webinar-hero.component';
import {
    WebinarTargetGroupComponent,
    WebinarTargetGroupLevel,
} from '../../components/webinar-target-group/webinar-target-group.component';
import {
    WebinarInstructor,
    WebinarInstructorSectionComponent,
} from '../../components/webinar-instructor-section/webinar-instructor-section.component';
import {WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER} from '../../webinar-instructors';
import {WebinarAgendaComponent, WebinarContent} from '../../components/webinar-agenda/webinar-agenda.component';
import {getParameterByName} from '../../../../shared/lib/get-parameters-by-name';
import {FormsModule} from '@angular/forms';
import {WebinarSignupSectionComponent} from '../../components/webinar-signup-section/webinar-signup-section.component';
import {isPlatformBrowser} from '@angular/common';
import {ExpertWebinarFaqs} from "../../components/expert-webinar-faq/expert-webinar-faqs.component";

@Component({
    selector: 'ax-erfahrungsaustausch-schliefer',
    standalone: true,
    imports: [
        FormsModule,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarInstructorSectionComponent,
        WebinarSignupSectionComponent,
        ExpertWebinarFaqs,
    ],
    templateUrl: './erfahrungsaustausch-schliefer.component.html',
    styleUrl: '../fachwebinare.scss',
})
export class ErfahrungsaustauschSchlieferComponent {
    protected readonly titleService = inject(Title);
    protected readonly metaService = inject(Meta);
    protected readonly httpClient = inject(HttpClient);
    protected readonly platformId = inject(PLATFORM_ID);

    protected webinarDate: string | null = null;
    protected webinarTitle = 'Erfahrungsaustausch online';
    protected webinarTitleShort = 'Online-Austausch';
    protected targetGroupLevel: WebinarTargetGroupLevel = {
        beginner: false,
        intermediate: true,
        professional: true,
    };
    protected instructors: Array<WebinarInstructor> = [WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER];
    protected price: number = 49;
    protected duration = 2;
    protected maximumNumberOfParticipants = 30;
    protected eventOverbooked = false;
    protected webinarContents: Array<WebinarContent> = [
        {
            title: 'Plattform zum Erfahrungsaustausch',
            description: 'Alle Themen rund um das Sachverständigenwesen',
        },
        // {
        //     title      : "Stempel und Unterschriften",
        //     description: "Best Practices und Anleitung"
        // },
        // {
        //     title      : "E-Mailsignaturen",
        //     description: "Einheitliche Grußformel unter E-Mails"
        // },
    ];

    constructor() {
        this.titleService.setTitle('Erfahrungsaustausch | Online-Stammtisch');
        this.metaService.addTag({
            name: 'description',
            content: 'Austausch für Kfz-Sachverständige - rund um autoiXpert',
        });
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.webinarDate = atob(getParameterByName('webinarDate') ?? '');
        }
    }
}
